<div
  class="fb-ctx-menu"
  *ngIf="visible"
  [style.left.px]="posX"
  [style.top.px]="posY">
  <button
    *ngFor="let item of items; trackBy: trackByIndex"
    class="fb-ctx-menu__item"
    [class.fb-ctx-menu__item--danger]="item.danger"
    [class.fb-ctx-menu__item--disabled]="item.disabled"
    (click)="onItemClick(item)">
    <i [class]="item.icon" class="fb-ctx-menu__icon"></i>
    <span>{{ item.label }}</span>
  </button>
</div>
